import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { ModelListResponse } from './model.types';
import { RouteParamsType } from '../../types/utils/router-params.type';
import { ModelType } from '../../types/inventory/inventory.types';
import { rejectWithApiError } from '../../utils/api';
import { RootReducerState } from '../../redux/Reducers';

export const getModelsList = createAsyncThunk(
  'models/getModelsList',
  async (
    params: RouteParamsType & {
      isRouter?: boolean;
      isSim?: boolean;
      isAta?: boolean;
      isBattery?: boolean;
      isDialer?: boolean;
      isEnclosure?: boolean;
      isPowerCycle?: boolean;
      isGlobal?: boolean;
      brand?: number;
      ports?: string;
    },
    thunkAPI
  ) => {
    try {
      const response = await axios.get<ModelListResponse>(`${process.env.REACT_APP_API_URL}/models`, {
        params,
      });
      return response.data;
    } catch (error) {
      return rejectWithApiError({ thunkAPI, error, fallback: 'Error fetching models list!' });
    }
  }
);

export const getModelDetails = createAsyncThunk<ModelType, number, { state: RootReducerState; rejectValue: string }>(
  'models/getModelDetails',
  async (id, thunkAPI) => {
    try {
      const response = await axios.get<ModelType>(`${process.env.REACT_APP_API_URL}/models/${id}`);
      return response.data;
    } catch (error) {
      return rejectWithApiError({ thunkAPI, error, fallback: 'Error fetching model details!' });
    }
  }
);

export const createModel = createAsyncThunk<
  ModelType,
  { name: string },
  { state: RootReducerState; rejectValue: string }
>('models/createModel', async (data, thunkAPI) => {
  try {
    const response = await axios.post<ModelType>(`${process.env.REACT_APP_API_URL}/models`, data);
    return response.data;
  } catch (error) {
    return rejectWithApiError({ thunkAPI, error, fallback: 'Error creating model!' });
  }
});

export const updateModel = createAsyncThunk(
  'models/updateModel',
  async ({ id, data }: { id: number; data: { name: string; isGlobal?: boolean } }, thunkAPI) => {
    try {
      const response = await axios.put<ModelType>(`${process.env.REACT_APP_API_URL}/models/${id}`, data);
      return response.data;
    } catch (error) {
      return rejectWithApiError({ thunkAPI, error, fallback: 'Error updating model!' });
    }
  }
);

export const deleteModelDetails = createAsyncThunk<
  ModelType,
  { id: number; fetchList?: boolean },
  { state: RootReducerState }
>('models/deleteModelDetails', async ({ id, fetchList = false }: { id: number; fetchList?: boolean }, thunkAPI) => {
  try {
    const response = await axios.delete(`${process.env.REACT_APP_API_URL}/models/${id}`);
    await new Promise(resolve => setTimeout(resolve, 1000));
    if (fetchList) {
      thunkAPI.dispatch(getModelsList(thunkAPI.getState().modelsReducer.modelsRouteParams));
    }
    return response.data;
  } catch (error) {
    return rejectWithApiError({ thunkAPI, error, fallback: `Error deleting model ${id}` });
  }
});
